import React, { useState, useEffect, useRef } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import imgUrl from "../../../images/timer.webp";
const TITLE = "المؤقت الزمني - مؤقت إلكتروني دقيق - تايمر الوقت";
const DESCRIPTION = "المؤقت الإلكتروني الدقيق للعد التنازلي والتصاعدي. أداة تايمر الوقت المثالية للطبخ، الرياضة، الدراسة، الصلاة، وأي أنشطة تحتاج توقيت دقيق. مؤقت سهل الاستخدام يعمل أونلاين بدون تحميل.";
const KEYWORDS = "مؤقت الوقت, عدّاد تنازلي, مؤقت إلكتروني, مؤقت طبخ, مؤتمر رياضة, مؤقت دراسة, عدّاد تصاعدي";
const OG_URL = "https://do-calculate.com/calculator/ar/timer/";
const Timer = () => {
    const [time, setTime] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [isCountdown, setIsCountdown] = useState(false);
    const [inputMinutes, setInputMinutes] = useState(0);
    const [inputSeconds, setInputSeconds] = useState(0);
    const [soundEnabled, setSoundEnabled] = useState(true);
    const audioContextRef = useRef(null);
    const hasPlayedSoundRef = useRef(false);
    const presetTimers = [
        [
            { label: "المؤقت لمدة 1 دقيقة", value: 60 },
            { label: "المؤقت لمدة 3 دقائق", value: 180 }
        ],
        [
            { label: "المؤقت لمدة 5 دقائق", value: 300 },
            { label: "المؤقت لمدة 10 دقائق", value: 600 }
        ],
        [
            { label: "المؤقت لمدة 15 دقيقة", value: 900 },
            { label: "المؤقت لمدة 20 دقيقة", value: 1200 }
        ],
        [
            { label: "المؤقت لمدة 30 دقيقة", value: 1800 },
            { label: "المؤقت لمدة 40 دقيقة", value: 2400 }
        ],
        [
            { label: "المؤقت لمدة 45 دقيقة", value: 2700 },
            { label: "المؤقت لمدة 60 دقيقة", value: 3600 }
        ],
        [
            { label: "المؤقت لمدة 10 ثواني", value: 10 },
            { label: "المؤقت لمدة 20 ثانية", value: 20 }
        ],
        [
            { label: "المؤقت لمدة 30 ثانية", value: 30 },
            { label: "المؤقت لمدة 45 ثانية", value: 45 }
        ],
        [
            { label: "المؤقت لمدة 60 ثانية", value: 60 },
            { label: "المؤقت لمدة 90 ثانية", value: 90 }
        ],
        [
            { label: "المؤقت لمدة 1 ساعة", value: 3600 },
            { label: "المؤقت لمدة 2 ساعات", value: 7200 }
        ],
        [
            { label: "المؤقت لمدة 4 ساعات", value: 14400 },
            { label: "المؤقت لمدة 8 ساعات", value: 28800 }
        ]
    ];
    // Initialize audio context
    useEffect(() => {
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        return () => {
            if (audioContextRef.current) {
                audioContextRef.current.close();
            }
        };
    }, []);
    // Play alarm sound using Web Audio API
    const playAlarmSound = () => {
        if (!soundEnabled || !audioContextRef.current) return;
        const context = audioContextRef.current;
        // Play a sequence of beeps
        const playBeep = (frequency, startTime, duration) => {
            const oscillator = context.createOscillator();
            const gainNode = context.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(context.destination);
            oscillator.frequency.value = frequency;
            oscillator.type = 'sine';
            gainNode.gain.setValueAtTime(0, startTime);
            gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.01);
            gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
            oscillator.start(startTime);
            oscillator.stop(startTime + duration);
        };
        const now = context.currentTime;
        // Play 3 beeps
        playBeep(800, now, 0.2);
        playBeep(800, now + 0.3, 0.2);
        playBeep(800, now + 0.6, 0.3);
    };
    useEffect(() => {
        setTime(0);
        setIsCountdown(false);
        setIsActive(true);
    }, []);
    useEffect(() => {
        let interval = null;
        if (isActive) {
            interval = setInterval(() => {
                setTime((prevTime) => {
                    if (isCountdown) {
                        if (prevTime <= 0) {
                            clearInterval(interval);
                            if (!hasPlayedSoundRef.current) {
                                playAlarmSound();
                                hasPlayedSoundRef.current = true;
                            }
                            return 0;
                        }
                        return prevTime - 1;
                    } else {
                        return prevTime + 1;
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isActive, isCountdown]);
    const toggleTimer = () => {
        setIsActive(!isActive);
    };
    const resetTimer = () => {
        setTime(0);
        setIsActive(false);
        hasPlayedSoundRef.current = false;
    };
    const startCountdown = () => {
        const totalSeconds = (inputMinutes * 60) + parseInt(inputSeconds);
        setTime(totalSeconds);
        setIsCountdown(true);
        setIsActive(true);
        hasPlayedSoundRef.current = false;
    };
    const handlePresetTimer = (seconds) => {
        setTime(seconds);
        setIsCountdown(true);
        setIsActive(true);
        setInputMinutes(Math.floor(seconds / 60));
        setInputSeconds(seconds % 60);
        hasPlayedSoundRef.current = false;
    };
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                IMAGE={imgUrl}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-12 col-md-4 text-center">
                    <img
                        src={imgUrl}
                        alt="مؤقت الوقت"
                        width="300px"
                        height="300px"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div
                        className="bg-success text-white text-center"
                        style={{ height: "50px" }}
                    >
                        <h1 style={{ fontSize: "17px" }}>
                            مؤقت الوقت الإلكتروني - عدّاد تنازلي
                        </h1>
                    </div>
                    <p>
                        استخدم هذا المؤقت الإلكتروني المجاني لضبط الوقت بدقة لأي نشاط،
                        سواء كان للطبخ، التمارين الرياضية، الدراسة، أو الصلاة. يمكنك
                        اختيار بين المؤقت التصاعدي (stopwatch) أو المؤقت التنازلي
                        (countdown timer) بسهولة وبواجهة بسيطة. استمتع بتجربة مؤقت
                        دقيقة وفعالة تلبي جميع احتياجاتك الزمنية.
                    </p>
                    <u>كيفية استخدام المؤقت:</u>
                    <ul>
                        <li>لتشغيل المؤقت التصاعدي، اضغط على زر "تشغيل".</li>
                        <li>لإيقاف المؤقت مؤقتًا، اضغط على زر "إيقاف".</li>
                        <li>لإعادة تعيين المؤقت إلى الصفر، اضغط على زر "إعادة تعيين".</li>
                        <li>لضبط المؤقت التنازلي، أدخل الدقائق والثواني المطلوبة ثم اضغط على "بدء العد التنازلي".</li>
                        <li>يمكنك أيضًا استخدام الأزرار المسبقة لضبط أوقات محددة بسرعة.</li>
                    </ul>
                    <MobileUnderCalAds />
                    <div
                        className="border border-light shadow-lg p-4 rounded"
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "10px",
                            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                        }}
                    >
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>عرض الوقت</h2>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <div className="text-center my-4">
                                        <div
                                            style={{
                                                background: "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                                                color: time <= 10 && isCountdown ? "#f44336" : "#4caf50",
                                                borderRadius: "50%",
                                                width: "200px",
                                                height: "200px",
                                                lineHeight: "200px",
                                                fontSize: "48px",
                                                fontWeight: "bold",
                                                margin: "0 auto",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                userSelect: "none",
                                            }}
                                        >
                                            {formatTime(time)}
                                        </div>
                                    </div>
                                    <div className="text-center mt-3 mb-3">
                                        <label style={{ fontSize: "14px", color: "#666" }}>
                                            <input
                                                type="checkbox"
                                                checked={soundEnabled}
                                                onChange={(e) => setSoundEnabled(e.target.checked)}
                                                style={{ marginLeft: "8px" }}
                                            />
                                            تفعيل الصوت عند انتهاء المؤقت
                                        </label>
                                    </div>
                                    <div className="text-center mt-2">
                                        <button
                                            className="text-white px-4 py-2 mx-2"
                                            style={{
                                                background: isActive
                                                    ? "linear-gradient(135deg, #f44336 0%, #e57373 100%)"
                                                    : "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={toggleTimer}
                                        >
                                            {isActive ? "إيقاف" : "بدء"}
                                        </button>
                                        <button
                                            className="text-white px-4 py-2 mx-2"
                                            style={{
                                                background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={resetTimer}
                                        >
                                            إعادة تعيين
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>ضبط المؤقت التنازلي</h2>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <div className="text-center my-4">
                                        <div className="d-flex justify-content-center">
                                            <div className="mx-2">
                                                <label>دقائق</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="59"
                                                    value={inputMinutes}
                                                    onChange={(e) => setInputMinutes(e.target.value)}
                                                    className="form-control text-center"
                                                    style={{ width: "90%" }}
                                                />
                                            </div>
                                            <div className="mx-2">
                                                <label>ثواني</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="59"
                                                    value={inputSeconds}
                                                    onChange={(e) => setInputSeconds(e.target.value)}
                                                    className="form-control text-center"
                                                    style={{ width: "90%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center mt-2">
                                        <button
                                            className="text-white px-4 py-2"
                                            style={{
                                                background: "linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={startCountdown}
                                        >
                                            بدء المؤقت التنازلي
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>مؤقتات جاهزة</h2>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <table className="bmi-table" style={{ width: "100%" }}>
                                        <tbody>
                                            {presetTimers.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((preset, colIndex) => (
                                                        <td
                                                            key={colIndex}
                                                            style={{
                                                                cursor: "pointer",
                                                                padding: "12px 8px",
                                                                color: "#1a73e8",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                                minWidth: "150px",
                                                                textAlign: "center",
                                                                border: "1px solid #e0e0e0",
                                                                transition: "all 0.3s ease",
                                                                backgroundColor: "#ffffff"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#f1f3f4";
                                                                e.currentTarget.style.color = "#0d47a1";
                                                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#ffffff";
                                                                e.currentTarget.style.color = "#1a73e8";
                                                                e.currentTarget.style.boxShadow = "none";
                                                            }}
                                                            onClick={() => handlePresetTimer(preset.value)}
                                                        >
                                                            <span style={{
                                                                borderBottom: "2px dotted #1a73e8",
                                                                paddingBottom: "2px",
                                                                transition: "all 0.3s ease"
                                                            }}>
                                                                <h3 style={{ fontSize: '15px' }}>{preset.label}</h3>
                                                            </span>
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                دليل استخدام المؤقت الإلكتروني
                            </div>
                            <div className="info-section-body">
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>ما هو المؤقت الإلكتروني؟</u>
                                    </h2>
                                    <p>
                                        <b>المؤقت الإلكتروني</b> أو <b>التايمر الرقمي</b> هو أداة مجانية تعمل عبر الإنترنت بدون الحاجة إلى تحميل أي تطبيقات. يوفر لك <b>مؤقت الوقت</b> هذا طريقة دقيقة وسهلة لتتبع الوقت في أي نشاط تقوم به، سواء كنت تحتاج إلى <b>عداد تنازلي</b> (countdown timer) أو <b>عداد تصاعدي</b> (stopwatch).
                                    </p>
                                    <p>
                                        يتميز هذا <b>المؤقت الزمني</b> بواجهة بسيطة وسهلة الاستخدام، مع إمكانية ضبط الوقت بالدقائق والثواني، بالإضافة إلى توفير مجموعة من <b>المؤقتات الجاهزة</b> للأوقات الشائعة الاستخدام. كما يتضمن <b>تنبيه صوتي</b> عند انتهاء الوقت المحدد لضمان عدم تفويت أي موعد أو مهمة.
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>كيفية استخدام المؤقت:</u>
                                    </h2>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>1. المؤقت التصاعدي (Stopwatch):</b>
                                    </h3>
                                    <ul>
                                        <li>اضغط على زر "بدء" لبدء حساب الوقت من الصفر</li>
                                        <li>يمكنك إيقاف المؤقت مؤقتاً بالضغط على "إيقاف" ثم استئنافه بالضغط على "بدء" مرة أخرى</li>
                                        <li>اضغط على "إعادة تعيين" لإعادة العداد إلى الصفر</li>
                                        <li>مثالي لقياس مدة تمرين رياضي، وقت دراسة، أو أي نشاط آخر</li>
                                    </ul>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>2. المؤقت التنازلي (Countdown Timer):</b>
                                    </h3>
                                    <ul>
                                        <li>أدخل عدد الدقائق والثواني المطلوبة في حقول الإدخال</li>
                                        <li>اضغط على زر "بدء المؤقت التنازلي" لبدء العد التنازلي</li>
                                        <li>سيتحول لون العداد إلى الأحمر عندما يتبقى 10 ثوانٍ أو أقل</li>
                                        <li>عند وصول الوقت إلى الصفر، سيصدر المؤقت صوت تنبيه (إذا كان مفعّلاً)</li>
                                        <li>يمكنك إيقاف أو إعادة تعيين المؤقت في أي وقت</li>
                                    </ul>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>3. استخدام المؤقتات الجاهزة:</b>
                                    </h3>
                                    <ul>
                                        <li>اختر من بين المؤقتات الجاهزة المتوفرة (من 10 ثوانٍ إلى 8 ساعات)</li>
                                        <li>اضغط على أي وقت من الجدول لبدء مؤقت تنازلي فوري</li>
                                        <li>سيتم ضبط الوقت تلقائياً وبدء العد التنازلي مباشرة</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>استخدامات المؤقت الإلكتروني:</u>
                                    </h2>
                                    <ul>
                                        <li><b>مؤقت الطبخ:</b> لضبط وقت طهي الأطعمة بدقة وتجنب حرقها أو عدم نضجها</li>
                                        <li><b>مؤقت الرياضة:</b> لتوقيت التمارين الرياضية، جلسات HIIT، أو فترات الراحة</li>
                                        <li><b>مؤقت الدراسة:</b> لتطبيق تقنية بومودورو (25 دقيقة عمل + 5 دقائق راحة)</li>
                                        <li><b>مؤقت الصلاة:</b> لتذكيرك بأوقات الصلاة أو تحديد وقت للذكر والقرآن</li>
                                        <li><b>مؤقت الاجتماعات:</b> لتنظيم وقت الاجتماعات والعروض التقديمية</li>
                                        <li><b>مؤقت الألعاب:</b> لتوقيت الألعاب والمسابقات العائلية</li>
                                        <li><b>مؤقت العناية الشخصية:</b> لتوقيت أقنعة الوجه، صبغة الشعر، أو العلاجات</li>
                                        <li><b>مؤقت العمل:</b> لتنظيم وقت العمل وزيادة الإنتاجية</li>
                                        <li><b>مؤقت الأطفال:</b> لتحديد وقت اللعب، المذاكرة، أو النوم</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>مميزات المؤقت:</u>
                                    </h2>
                                    <ul>
                                        <li>واجهة بسيطة وسهلة الاستخدام مع عرض واضح للوقت</li>
                                        <li>يعمل أونلاين بدون تحميل أو تثبيت</li>
                                        <li>مجاني 100% بدون إعلانات مزعجة</li>
                                        <li>تنبيه صوتي عند انتهاء المؤقت التنازلي (يمكن تفعيله أو إلغاؤه)</li>
                                        <li>تغيير لون العداد إلى الأحمر في آخر 10 ثوانٍ للتنبيه البصري</li>
                                        <li>مؤقتات جاهزة للأوقات الشائعة الاستخدام</li>
                                        <li>إمكانية الإيقاف المؤقت والاستئناف</li>
                                        <li>إعادة تعيين سريعة للبدء من جديد</li>
                                        <li>متوافق مع جميع الأجهزة (كمبيوتر، هاتف، تابلت)</li>
                                        <li>دقة عالية في توقيت الثواني</li>
                                        <li>تصميم جذاب مع تأثيرات بصرية احترافية</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>تقنية بومودورو (Pomodoro Technique):</u>
                                    </h2>
                                    <p>
                                        يعتبر <b>المؤقت الإلكتروني</b> أداة مثالية لتطبيق تقنية بومودورو الشهيرة لزيادة الإنتاجية والتركيز:
                                    </p>
                                    <ol>
                                        <li>اختر مهمة للعمل عليها</li>
                                        <li>اضبط المؤقت على 25 دقيقة (استخدم مؤقت 20 دقيقة + 5 دقائق)</li>
                                        <li>اعمل على المهمة بتركيز كامل حتى ينتهي الوقت</li>
                                        <li>خذ استراحة قصيرة لمدة 5 دقائق</li>
                                        <li>بعد 4 جلسات، خذ استراحة طويلة (15-30 دقيقة)</li>
                                    </ol>
                                    <p>
                                        استخدم <b>المؤقتات الجاهزة</b> في الأسفل لاختيار 30 دقيقة للعمل أو 5 دقائق للراحة بضغطة واحدة!
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>نصائح للاستخدام الأمثل:</u>
                                    </h2>
                                    <ol>
                                        <li>تأكد من تفعيل الصوت في متصفحك لسماع التنبيه عند انتهاء الوقت</li>
                                        <li>استخدم المؤقتات الجاهزة للوصول السريع للأوقات الشائعة</li>
                                        <li>راقب تغيير لون العداد للأحمر في آخر 10 ثوانٍ كتحذير بصري</li>
                                        <li>يمكنك إيقاف المؤقت مؤقتاً إذا احتجت لذلك دون خسارة الوقت</li>
                                        <li>استخدم المؤقت التصاعدي لقياس المدة الفعلية للمهام</li>
                                        <li>اضبط عدة مؤقتات على أجهزة مختلفة لتتبع مهام متعددة</li>
                                        <li>اجعل صفحة المؤقت مرجعية في متصفحك للوصول السريع</li>
                                    </ol>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>الأسئلة الشائعة:</u>
                                    </h2>
                                    <p><b>هل يعمل المؤقت في الخلفية؟</b></p>
                                    <p>نعم، يستمر المؤقت في العمل حتى لو انتقلت إلى تبويب آخر في المتصفح.</p>
                                    <p><b>هل أحتاج إلى اتصال بالإنترنت؟</b></p>
                                    <p>تحتاج الإنترنت فقط لتحميل الصفحة في المرة الأولى، بعدها يعمل المؤقت بدون اتصال.</p>
                                    <p><b>هل يمكنني استخدام أكثر من مؤقت في نفس الوقت؟</b></p>
                                    <p>يمكنك فتح الصفحة في عدة تبويبات أو نوافذ مختلفة، كل واحدة بمؤقت مستقل.</p>
                                    <p><b>ماذا يحدث عند انتهاء المؤقت؟</b></p>
                                    <p>يتوقف المؤقت عند الصفر، ويصدر صوت تنبيه إذا كان مفعّلاً، ويتحول لون العرض للأحمر.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
};
export default Timer;